// A connection string is a ";"-separated key=value list. The instrumentation key must be
// exactly a GUID: a placeholder, or a GUID with anything appended, still loads the SDK and
// then fails every send with 400 "Invalid instrumentation key".
const INSTRUMENTATION_KEY =
  /(?:^|;)\s*InstrumentationKey=[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\s*(?:;|$)/i;

export const hasValidInstrumentationKey = (connectionString?: string): boolean =>
  INSTRUMENTATION_KEY.test(connectionString ?? "");

// The key is a deploy-wide constant, so one report per tab tells us everything a report on
// every page load would — and captureConsoleIntegration turns each console.error into a
// Sentry event, which at this site's traffic would burn quota and bury other issues.
// Storage is unavailable in some contexts (private windows, blocked site data); a duplicate
// report is a better failure than silence, so those fall through to reporting.
export const isFirstReportThisSession = (key: string): boolean => {
  try {
    if (sessionStorage.getItem(key)) return false;
    sessionStorage.setItem(key, "1");
    return true;
  } catch {
    return true;
  }
};
